import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, OnDestroy} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, NgbTypeahead, NgbHighlight } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from '../../../core/services/event.service';
import { AutocompleteService } from '../../../core/services/autocomplete.service';
import { Observable, of, OperatorFunction, Subscription} from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UtilityService } from '../../../core/services/utility.service';
import { MediaUploadService } from '../../../core/services/mediaUpload.service';
import { ConfirmAlertComponent } from '../confirm-alert/confirm-alert.component';
import { ToastrService } from 'ngx-toastr';
import { ThirtySecondsVideoRecordModalComponent } from '../thirty-seconds-video-record-modal/thirty-seconds-video-record-modal.component';
import { CitySuggestionComponent } from '../city-suggestion/city-suggestion.component';
import { ScrollSelectComponent, ScrollSelectOption } from '../scroll-select/scroll-select.component';
import { InputRestrictionDirective } from '../../directives/input-restriction.directive';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { LogoUrlPipe, normalizeLogoUrl } from '../../pipes/logo-url.pipe';

@Component({
    selector: 'add-experience-modal',
    templateUrl: './add-experience-modal.component.html',
    styleUrls: ['./add-experience-modal.component.scss'],
    imports: [NgClass, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, FormsModule, NgbTypeahead, InputRestrictionDirective, NgbHighlight, CitySuggestionComponent, ScrollSelectComponent, LogoUrlPipe]
})
export class AddExperienceModalComponent implements OnInit, AfterViewInit, OnDestroy {
	private subs = new Subscription();


	@Input() data: any = {};
	@Input() id: any;
	@Input() delete: boolean = false;
	@Input() pageStatus: any;
	@Input() ctrl: any;
	@Output() deleteFn: EventEmitter<any> = new EventEmitter<any>();
	@Output() getEditdataFn: EventEmitter<any> = new EventEmitter<any>();
	@Output() experienceAddedFn: EventEmitter<any> = new EventEmitter<any>();
	@Output() getEditdataFnGs: EventEmitter<any> = new EventEmitter<any>();
	@Output() experienceAddedFnGs: EventEmitter<any> = new EventEmitter<any>();


	public fileServerUrl: string = environment.urls.fileServerUrl_Obj;

	private companySelected: boolean = false;
	private citySelected: boolean = false;
	private videoData: any;
	private oldData: any;
	private oldDataGT: any;
	private inGetStartedController: any;

	public videoEditted: boolean = false;
	public videoDeleted: boolean = false;
	public muteClassAdd: boolean = true;
	public posSelected: boolean = false;
	public startYear: string = 'Year:';
	public currentYear: any = new Date().getFullYear();
	public maximumYear: any = this.currentYear + 12;
	public endYear: string = 'Year:';
	public endYears: number[] = [];

	/** Option lists for <scroll-select>. A native <select> popup is drawn by the
	 *  operating system, so a 64-entry year list covers the whole window and no
	 *  CSS can cap it; scroll-select renders its own menu capped at ten rows. */
	public yearOptions: ScrollSelectOption[] = [];
	public endYearOptions: ScrollSelectOption[] = [];
	public company: string = '';
	public companyId: any;
	public companyErrorMessage: string = '';
	public showCompanyError: boolean = false;
	public companyUrl: any;
	public position: string = '';
	public positionId: any;
	public positionErrorMessage: string = '';
	public showPositionError: boolean = false;
	public city: string = '';
	public cityErrorMessage: string = '';
	public showCityError: boolean = false;
	public description: string = '';
	public endMonth: any = { id: '0' };
	public endDateErrorMessage: string = '';
	public endDateError: boolean = false;
	public startMonth: any = { id: '0' };
	public startDateErrorMessage: string = '';
	public startDateError: boolean = false;
	public timePeriodErrorMessage: string = '';
	public timePeriodError: boolean = false;
	public selectedVideoUrl: any;
	public videoSelected: any;
	public rawVideoUrl: any;
	public isCurrentlyWorking: any;
	public maxLength: number = 2000;
	public suggestionsCompany: any[] = [];
	public hasToShowCompanySuggestions: boolean = false;
	public showCompanyAddtolist: boolean = false;
	public suggestionsPosition: any[] = [];
	public hasToShowPositionSuggestions: boolean = false;
	public showpositionAddtolist: boolean = false;
	public photoSelected: boolean = false;
	public selectedPhoto: any;

	public parentobj: any = {
		city: '',
		showCityError: ''
	};

	public valueUpdated: boolean = false;

	constructor(public modal: NgbActiveModal,
		private sanitizer: DomSanitizer,
		private autocompleteService: AutocompleteService,
		private eventService: EventService,
		private modalService: NgbModal,
		private utilityService: UtilityService,
		private mediaUploadService: MediaUploadService,
		private toastr: ToastrService) { }

	ngOnInit() {


		this.yearOptions = Array.from({ length: 64 },
			(_, i) => ({ value: `${this.currentYear - i}`, label: `${this.currentYear - i}` }));

		this.data.months_new = [
			{ id: '0', name: 'Month' },
			{ id: '1', name: 'January' },
			{ id: '2', name: 'February' },
			{ id: '3', name: 'March' },
			{ id: '4', name: 'April' },
			{ id: '5', name: 'May' },
			{ id: '6', name: 'June' },
			{ id: '7', name: 'July' },
			{ id: '8', name: 'August' },
			{ id: '9', name: 'September' },
			{ id: '10', name: 'October' },
			{ id: '11', name: 'November' },
			{ id: '12', name: 'December' }
		];

		this.data.months_start = [...this.data.months_new];
		this.data.months_end = [...this.data.months_new];
		// condition if edit on get started page
		if (this.id && this.data) {
			this.inGetStartedController = true;
			let data = this.data;
			this.oldDataGT = this.data;
			if (data) {
				this.id = data.id;
				this.company = data.companyName;
				this.companyId = data.companyName;
				this.companyUrl = data.companyUrl;
				this.position = data.positionName;
				this.positionId = data.positionName;
				this.city = data.city;
				this.description = data.description;
				this.startYear = data.startYear.toString();
				this.endYear = data.endYear.toString();
				this.startMonth = { id: data.startMonth != null ? data.startMonth.toString() : '0' };
				this.endMonth = { id: data.endMonth != null ? data.endMonth.toString() : '0' };
				this.videoData = data.videoUrl;
				this.selectedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.videoUrl);
				this.videoSelected = !((data.videoUrl.toString() === '' || data.videoUrl.toString() === this.fileServerUrl));
				this.rawVideoUrl = data.videoUrl;
				this.isCurrentlyWorking = data.isWorking;
				this.updateEndYears();
			}
		}

		// condition if on profile page
		if (this.data && this.data.COGUID) {
			this.inGetStartedController = false;
			let data = this.data;

			this.oldData = this.data;
			this.id = data.Id;
			if (data) {
				this.id = data.Id;
				this.company = data.Employer.Name;
				this.companyId = data.Employer.Name;
				this.companyUrl = normalizeLogoUrl(data.Employer.LogoUrl);
				this.position = data.JobTitle;
				this.positionId = data.JobTitle;
				this.city = data.Location;
				this.description = data.Notes || '';
				this.startYear = data.StartDate.toString();
				this.endYear = data.EndDate.toString();
				this.startMonth = { id: data.StartMonth != null ? data.StartMonth.toString() : '0' };
				this.endMonth = { id: data.EndMonth != null ? data.EndMonth.toString() : '0' };
				this.videoData = undefined;
				this.videoSelected = !((data.VideoUrl.toString() === '' || data.VideoUrl.toString() === this.fileServerUrl));
				this.selectedVideoUrl =data.VideoUrl ? this.sanitizer.bypassSecurityTrustResourceUrl(data.VideoUrl) : '' ;
				// was '' here, which dropped the existing video's path on edit
			this.rawVideoUrl = data.VideoUrl || '';
				this.isCurrentlyWorking = (data.EndDate === 0 || data.EndDate === 'Present');
				this.updateEndYears();
			}

		}

		this.updateEndYears();

		this.subs.add(this.eventService.subscribe('video-selected', (value) => {
			// video selected
			this.muteClassAdd = true;
			this.videoEditted = true;
			this.videoSelected = true;
			this.selectedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(value.data.url);
			this.videoData = value.data.videoData;
			this.rawVideoUrl = value.data.url;
			if (document.getElementById('muteBtn')) {
				this.muted(true);
			}
			this.valueUpdated = true;
		}));

	}

	ngAfterViewInit() {
		this.muted(true);
	}

	remaining() {
		const textarea = document.getElementsByTagName('textarea')[0];
		return this.maxLength - (textarea?.value.length || 0);
	}

	muted(val: boolean) {
		if (val !== undefined && val !== null) {
			const vid = document.getElementById('vidPreview') as HTMLMediaElement;
			if (vid) vid.muted = val;
			this.muteClassAdd = val;
		}
	}
	recordVideo() {


		this.muteClassAdd = true;
		this.muted(true);

		// Delay modal opening slightly
		setTimeout(() => {
			this.modalService.open(ThirtySecondsVideoRecordModalComponent,
				{ windowClass: 'modal-theme-unnanu-v2 video-recorder-popup', backdrop: 'static', keyboard: false });
		}, 50);


	}
	positionVideo() {
		const selectedVideo = document.querySelector('#vidPreview') as HTMLElement;
		if (!selectedVideo) return;
		const leftMargin = ((selectedVideo.offsetWidth - selectedVideo.offsetHeight) / 2) * -1;
		selectedVideo.style.marginLeft = `${leftMargin}px`;
		if (!this.videoEditted) {
			this.muted(true);
		}
	}


	suggestCompanies() {
		this.validateCompany();
		this.companySelected = false;
		if (this.company) {
			if (this.company.trim().length >= 3) {
				return this.autocompleteService.get(this.company, 'company').pipe(map((response: any) => {
					if (
						response.status === 200 &&
						response.Code === 200 &&
						response.Data.length > 0
					) {
						this.suggestionsCompany = response.Data;
						this.hasToShowCompanySuggestions = true;
						this.showCompanyAddtolist = false;
						return this.suggestionsCompany.slice(0, 10);
					} else {
						// Add New Position
						this.suggestionsCompany = [];
						this.hasToShowCompanySuggestions = false;
						return this.suggestionsCompany.slice(0, 10);
					}
				})
				);
			} else {
				this.hasToShowCompanySuggestions = false;
				return of([]);
			}
		} else {
			return of([]);
		}
	}

	searchCompany: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			switchMap(() => this.suggestCompanies().pipe(catchError(() => of([]))))
		)

	companySelectedFn(event: any) {
		event.preventDefault();
		let companyName = event.item.Name;
		let id = event.item.AuthorityId;
		let url = normalizeLogoUrl(event.item.LogoUrl);
		if (companyName !== '') {
			this.company = companyName;
			this.companyId = id;
			this.companyUrl = url;
			this.hasToShowCompanySuggestions = false;
			this.companySelected = true;
			this.showCompanyAddtolist = false;
		} else {
			this.company = '';
			this.showCompanyAddtolist = false;
		}
	}

	hideCompanySuggestions() {
		// Same copy-paste as the education modal: this compared against
		// oldData.Authority, but an experience record carries Employer, so
		// reading .Name off undefined threw on every blur of the Company field.
		// Every branch body was commented out, so the tree is gone rather than
		// repointed - it only ever guarded dead code.
		this.company = this.company.trim();
		this.hasToShowCompanySuggestions = false;
		this.validateCompany();
	}

	validateCompany() {
		if (!this.company.trim()) {
			this.companyErrorMessage = 'Enter certifying authority';
			this.showCompanyError = true;
		} else {
			this.showCompanyError = false;
		}
	}

	suggestPositions() {
		this.validatePosition();
		if (this.position.trim().length >= 3) {
			return this.autocompleteService.get(this.position, 'profession').pipe(map((response: any) => {
				if (
					response.status === 200 &&
					response.Code === 200 &&
					response.Data.length > 0
				) {
					this.suggestionsPosition = response.Data;
					this.hasToShowPositionSuggestions = true;
					return this.suggestionsPosition.slice(0, 10);
				} else {
					// Add New Position
					this.suggestionsPosition = [];
					this.hasToShowPositionSuggestions = false;
					return this.suggestionsPosition.slice(0, 10);
				}
			})
			);
		} else {
			this.hasToShowPositionSuggestions = false
			return of([]);
		}
	}

	searchPosition: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			switchMap(() => this.suggestPositions().pipe(catchError(() => of([]))))
		)

	positionFormatter = (result: any) => result.Name;

	positionSelected(event: any) {
		event.preventDefault();
		let positionName = event.item.Name;
		let id = event.item.Id;
		if (positionName !== '') {
			this.posSelected = true;
			this.position = positionName;
			this.positionId = id;
			this.showpositionAddtolist = false;
		} else {
			this.position = '';
		}
		this.showpositionAddtolist = false;
	}

	hidePositionSuggestions() {
		this.position = this.position.trim();
		this.hasToShowPositionSuggestions = false
		if (!this.posSelected) {
			if (!this.inGetStartedController && this.oldData) {
				if (this.oldData.JobTitle !== this.position) {
					// this.position = '';
				}
			} else {
				// this.position = '';
				if (this.inGetStartedController && this.oldDataGT) {
					if (this.oldDataGT.positionName !== this.position) {
						// this.position = '';
					}
				} else {
					// this.position = '';
				}
			}
			this.validatePosition();
		}
	}

	validatePosition() {
		if (!this.position.trim()) {
			this.positionErrorMessage = 'Please select your position';
			this.showPositionError = true;
		} else {
			this.showPositionError = false;
		}
	}

	validateCity() {
		if (this.city === '' && this.parentobj.city === '') {
			this.cityErrorMessage = 'Enter location';
			this.showCityError = true;
		} else {
			this.showCityError = false;
		}
	}

	deleteData() {
		if (this.delete) {
			this.deleteFn.emit(this.data.COGUID);
			this.close();
		}
	}

	saveData() {
		this.company = this.company.trim();
		this.position = this.position.trim();
		this.validateTimePeriod()
		this.validatePosition();
		this.validateCity();
		this.validateCompany();

		if ((this.showCompanyError || this.showPositionError || this.parentobj.showCityError || this.startDateError || this.endDateError || this.timePeriodError)) {

		} else {
			let guid;
			if (this.data.id) {
				guid = this.id;
			} else if (this.data && this.data.COGUID) {
				guid = this.data.COGUID;
			} else {
				guid = this.utilityService.genGuid();
			}
			let experienceObject = {
				key: guid,
				value: {
					id: this.id,
					companyName: this.company,
					companyId: this.company,
					companyUrl: this.companyUrl,
					positionName: this.position,
					positionId: this.position,
					city: (this.parentobj.city !== '' ? this.parentobj.city : this.city),
					description: this.description,
					startYear: this.startYear,
					endYear: (this.isCurrentlyWorking) ? 0 : this.endYear,
					startMonth: Number(this.startMonth.id),
					endMonth: Number(this.endMonth.id),
					videoData: this.videoData,
					// rawVideoUrl, not selectedVideoUrl. selectedVideoUrl is a
					// SafeResourceUrl, and calling toString() on one returns Angular's
					// wrapper text - "SafeValue must use [property]=binding: <url>" -
					// not the URL. rawVideoUrl holds the path the server gave us and
					// was already being assigned for exactly this purpose, but nothing
					// ever read it.
					videoUrl: this.rawVideoUrl || '',
					isWorking: this.isCurrentlyWorking,
					isSaved: false
				}
			}


			if (this.id || (this.data && this.data.COGUID)) {
				if (this.pageStatus === 1) {
					this.getEditdataFn.emit({ data: experienceObject, videoEditted: this.videoEditted, ctrl: this.ctrl, videoDeleted: this.videoDeleted })
					this.eventService.broadcast('experience-saved',{
						response: experienceObject
					})
				} else {
					this.getEditdataFnGs.emit({ data: experienceObject, videoEditted: this.videoEditted, ctrl: this.ctrl, videoDeleted: this.videoDeleted })
				}
			} else {
				if (this.pageStatus === 1) {
					this.experienceAddedFn.emit({ data: experienceObject, ctrl: this.ctrl, videoEditted: this.videoEditted })
				} else {
					this.experienceAddedFnGs.emit({ data: experienceObject, ctrl: this.ctrl, videoEditted: this.videoEditted })
				}
			}
			this.close();
		}
	}

	currentlyWorking() {
		this.endYear = 'Year:';
		this.endMonth = { id: '0' };
		this.endDateError = false;
		this.timePeriodError = false;
		this.updateEndYears();
	}

	public updateEndYears() {
		const fromYear = this.startYear !== 'Year:' ? Number(this.startYear) : null;
		const minYear = fromYear !== null ? fromYear : this.currentYear - 63;
		this.endYears = [];
		for (let y = this.maximumYear; y >= minYear; y--) {
			this.endYears.push(y);
		}
		this.endYearOptions = this.endYears.map(y => ({ value: `${y}`, label: `${y}` }));
		if (fromYear !== null && this.endYear !== 'Year:' && Number(this.endYear) < fromYear) {
			this.endYear = 'Year:';
			this.endMonth = { id: '0' };
		}
	}

	// time period field validation
	public validateTimePeriod() {
		this.updateEndYears();
		if (this.startMonth.id === '0' || this.startYear === 'Year:') {
			this.startDateErrorMessage = 'Please enter the joining date';
			this.startDateError = true;
		} else {
			this.startDateError = false;
		}

		if (this.endMonth.id === '0' || this.endYear === 'Year:') {
			this.endDateErrorMessage = 'Select month & year';
			this.endDateError = true;
		} else {
			this.endDateError = false;
		}

		const startY = Number(this.startYear);
		const endY = Number(this.endYear);
		const startM = Number(this.startMonth.id);
		const endM = Number(this.endMonth.id);

		if (!this.isCurrentlyWorking && endY !== 0) {
			if (endY < startY) {
				this.timePeriodErrorMessage = 'End date cannot be before start date';
				this.timePeriodError = true;
			} else if (endY === startY && endM < startM) {
				this.timePeriodErrorMessage = 'End date cannot be before start date';
				this.timePeriodError = true;
			} else if (endY === startY && endM === startM) {
				this.timePeriodErrorMessage = 'End date cannot be the same as start date';
				this.timePeriodError = true;
			} else {
				this.timePeriodError = false;
			}
		} else {
			this.timePeriodError = false;
		}

		if (this.isCurrentlyWorking) {
			this.endDateError = false;
		}
	}

	removeVideo() {
		const confirmModal = this.modalService.open(ConfirmAlertComponent, { backdrop: 'static', keyboard: false });
		confirmModal.componentInstance.msg = 'Are you sure you want to delete this video?';
		confirmModal.result.then(() => {
			if (this.id) {
				this.mediaUploadService.removePhoto('EXPER_VIDEO', this.id).subscribe({
					next: () => {},
					error: (err: any) => {
						this.toastr.error(err?.error?.Message || err?.message || 'An unexpected error occurred. Please try again.');
					}
				});
			}
			this.videoEditted = false;
			this.videoDeleted = true;
			this.videoSelected = false;
			this.selectedVideoUrl = undefined;
			this.videoData = undefined;
			if (document.getElementById('vidPreview')) {
				(document.getElementById('vidPreview') as HTMLMediaElement).muted = true;
			}
		}, () => {});
	}

	get startMonthOptions(): ScrollSelectOption[] {
		return (this.data?.months_start || []).map((m: any) => ({ value: m.id, label: m.name }));
	}

	get endMonthOptions(): ScrollSelectOption[] {
		return (this.data?.months_end || []).map((m: any) => ({ value: m.id, label: m.name }));
	}

	getArray(n: number) {
		return new Array(n);
	}

	adjustCalenderStart(selectedDate: any) {

		let date = new Date()
		if (date.getFullYear() === Number(selectedDate)) {
			this.data.months_start = this.data.months_start.splice(0, date.getMonth() + 2);
		} else {
			if (this.data.months_start.length !== 13) {
				this.data.months_start = [...this.data.months_new];
			}
		}
	}

	adjustCalenderEnd(selectedDate: any) {

		let date = new Date()
		if (date.getFullYear() === Number(selectedDate)) {
			this.data.months_end = this.data.months_end.splice(0, date.getMonth() + 2);
		} else {
			if (this.data.months_end.length !== 13) {
				this.data.months_end = [...this.data.months_new];
			}
		}
	}

	onChange(event: any){
		this.valueUpdated = true;
	}

	close() {
		this.modal.dismiss();
	}


	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}
}
